
import { intersect } from '@/utils/tools'
import { computed, watch } from 'vue'
import { useCommon } from '@/store/useCommon';

let ownPermission = computed(() => {
  return useCommon().userData.permissionKey || []
})

function toolPermission(el, permission) {
  if (permission && !intersect(ownPermission.value, permission.split(','))) {
    el.parentNode && el.parentNode.removeChild(el) // 关键代码, 没有权限则删除元素
  }
}

export default {
  mounted(el, binding) {
    toolPermission(el, binding.value)
  },
  updated(el, binding) {
    toolPermission(el, binding.value)
  },
}
